import angularModule from 'Onboarding/angularModule/scripts/onboarding_module';
import template from 'Onboarding/angularModule/views/onboarding.hybrid.register.html';
import cacheAngularTemplate from 'cacheAngularTemplate';
import { gsap } from 'FrontRoyalGsap';
import { targetBrandConfig } from 'AppBranding';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('onboardingHybridRegister', [
    '$injector',
    function factory($injector) {
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const scopeTimeout = $injector.get('scopeTimeout');
        const $routeParams = $injector.get('$routeParams');
        const ConfigFactory = $injector.get('ConfigFactory');
        const safeDigest = $injector.get('safeDigest');
        const EventLogger = $injector.get('EventLogger');

        return {
            restrict: 'E',
            templateUrl,
            scope: {},
            link(scope) {
                EventLogger.log('debug_onboarding_issue:onboarding_hybrid_register_init', {
                    params: { $routeParams },
                });

                NavigationHelperMixin.onLink(scope);
                const config = ConfigFactory.getSync();

                scope.brandStyleClass = targetBrandConfig(null, config).brandStyleClass;

                scope.headerTextKey = 'header_text';
                const balloon = document.querySelectorAll('.hybrid__header__message');
                const balloonText = document.querySelectorAll('.hybrid__header__message__text');
                let balloonTextParagraph = document.querySelectorAll('.hybrid__header__message__text p');
                const loading = document.querySelectorAll('.hybrid__header__loading');
                const form = document.querySelectorAll('.onboarding__form');
                const headerContainer = document.querySelectorAll('.hybrid__header');
                const formContainer = document.querySelectorAll('.onboarding__form');

                scope.startInitialAnimations = () => {
                    $(headerContainer).css({
                        opacity: 0,
                    });

                    $(formContainer).css({
                        opacity: 0,
                    });

                    scopeTimeout(
                        scope,
                        () => {
                            $(headerContainer).css({
                                opacity: 1,
                            });

                            $(formContainer).css({
                                opacity: 1,
                            });
                            const timeline = gsap.timeline({
                                onComplete() {
                                    scope.showFooter = true;
                                    safeDigest(scope);
                                },
                            });
                            balloonTextParagraph = document.querySelectorAll('.hybrid__header__message__text p');
                            timeline.set(balloonTextParagraph, {
                                display: 'none',
                                opacity: 0,
                            });
                            timeline
                                .to(loading, {
                                    duration: 0.6,
                                    opacity: 0,
                                    display: 'none',
                                })
                                .to(
                                    balloon,
                                    {
                                        duration: 0,
                                        // removes jank
                                        width: '70px',
                                    },
                                    '-=0.6',
                                )
                                .to(balloon, {
                                    duration: 0.3,
                                    width: '194px',
                                })
                                .fromTo(
                                    balloonTextParagraph,
                                    {
                                        opacity: 0,
                                        display: 'none',
                                    },
                                    {
                                        duration: 0.3,
                                        opacity: 1,
                                        display: 'inline-block',
                                    },
                                )
                                .from(form, {
                                    duration: 0.3,
                                    y: 400,
                                    opacity: 0,
                                })
                                .from(
                                    form,
                                    {
                                        duration: 0.3,
                                        scale: 0,
                                        ease: 'power2.inOut',
                                    },
                                    '-=0.3',
                                );
                        },
                        0,
                    );

                    scope.animated = true; // for tests
                };

                if ($routeParams.animate) {
                    scope.startInitialAnimations();
                } else {
                    $(loading).hide();
                    $(balloon).css({
                        width: '194px',
                    });
                    $(balloonText).css({
                        display: 'inline-block',
                        width: '100%',
                        height: '100%',
                    });
                    $(balloonTextParagraph).each(function () {
                        $(this).show();
                        $(this).css({
                            display: 'inline-block !important',
                        });
                    });

                    scope.animated = false; // for tests
                    scope.showFooter = true;
                }
            },
        };
    },
]);
